export default __webpack_public_path__ + "static/media/lecteur-RFID-125.8272d87b.png";